import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const BackDatedEventDetailStyle = makeStyles({
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    marginTop: "30px",
    marginBottom: "10px",
    "& h2": {
      fontSize: "18px",
      fontWeight: 600,
      position: "relative",
      "& .MuiSvgIcon-root": {
        position: "absolute",
        color: "#999",
        top: 0,
        right: "-20px",
        fontSize: "16px",
      }
    }
  },
  changeSummaryBox: {
    backgroundColor: "#f4faff",
    border: "1px solid #2196f3",
    borderRadius: 8,
    padding: 16,
    margin: "24px 0",
    "& .title": {
      fontWeight: 600,
      marginBottom: 12,
      color: "#007bff",
    },
  },

  summaryContent: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    rowGap: 16,
  },

  summaryItem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minWidth: 200,
  },
  backLinkWrapper: {
    marginBottom: "20px",
    "& a": {
      fontSize: "18px",
      lineHeight: "1.2",
      position: "relative",
      fontWeight: "500",
      color: colors.orange,
      display: "inline-flex",
      alignItems: "center",
      "& svg": {
        height: 15,
        width: 15,
      },
    },
  },
  innerPageTopBlock: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media (max-width: 1359px)": {
      flexWrap: "wrap",
    },
    "@media (max-width: 1190px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "10px",
    },
    "& h1": {
      fontSize: "30px",
      color: colors.black,
      textTransform: "capitalize",
      margin: "0 20px 0 0",
    },
    "& .right-block": {
      flex: "1",
      "& .right-block-inner": {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        "@media (max-width: 1300px)": {
          flexWrap: "wrap",
        },
        "@media (max-width: 574px)": {
          flexDirection: "column",
          gap: "10px",
          justifyContent: "center",
        },
      },
    },
    "& .left-block": {
      paddingRight: "10px",
      "@media (max-width: 1359px)": {
        maxWidth: "100%",
        padding: "0px",
      },
    },
  },
  subTitle: {
    color: "#6d6d6d",
    marginTop: "4px",
  },
  spin: {
    animation: "$spin 1s linear infinite",
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
});

export { BackDatedEventDetailStyle };
